import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import CustomDialog from "components/CustomDialog";
import React, { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  getProductGroupImagesThunk,
  setProductGroupImageThunk,
} from "store/reducers/product/productGroupsSlice";

const ProductGroupEditImageDialog = ({ open, handleClose, group }) => {
  const { imageStatus, images } = useSelector((state) => state.productGroup);
  useEffect(() => {
    // console.log("Group", group);
    dispatch(getProductGroupImagesThunk(group.id));
  }, [group, group.id]);

  // useEffect(() => {
  //   console.log("Images:", images);
  //   console.log("images[group.id] : ", images[group.id]);
  // }, [group.id, images]);

  const setImage = (image) => {
    
    dispatch(
      setProductGroupImageThunk({
        id: group.id,
        data: { product_image: image.id },
      })
    );
    handleClose()
  };

  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Choose an image"
    >
      <Box sx={{ overflow: "hidden", padding: 2 }}>
        {imageStatus?.loading === "get" && <CircularProgress />}
        {imageStatus?.success === "get" &&
        images[group.id] &&
        images[group.id].length > 0 ? (
          <Grid container spacing={3}>
            {images[group.id].map((image) => (
              <Grid item xs={6} md={4} key={image.id}>
                <Paper
                  elevation={2}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <LazyLoadImage src={image.image} style={{ height: 120 }} />
                  <Button
                    variant="text"
                    onClick={() => {
                      setImage(image);
                    }}
                  >
                    Select
                  </Button>
                </Paper>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography variant="h6">
            None of the products in this group have an image , kindly upload a
            few !
          </Typography>
        )}
      </Box>
    </CustomDialog>
  );
};

export default ProductGroupEditImageDialog;
